import { useEffect, useState, useMemo } from "react";
import { getData } from "../../../../services/library";
import moment from "moment";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { logEventos } from "../../../../services/services";
import Navbar from "../../../Navbar";
import {Divider, Container, Box, Typography, MenuItem, ListItemIcon, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { Preview } from '@mui/icons-material';

export default function Requerimientos_rechazados() {
    const [showReqs, setshowReqs] = useState([]);
    const [showTabla, setshowTabla] = useState(true);
    const [openclose, setopenclose] = useState(false);
    const [dataReq, setdataReq] = useState({});

    const getRequerimientos = () => {
        getData('/requerimientos_materiales/historial_rechazados', setshowReqs)
    };

    useEffect(() => {
        getRequerimientos();
        logEventos('Visualizar historial requerimientos rechazados', 'Historial requerimientos', 'Compras', localStorage.getItem('user'));
    }, []);

    const columns = useMemo(() =>
        [{ header: '#', accessorKey: 'id', size: 90 },
        { header: 'Movil', accessorKey: 'patente', size: 120 },
        { header: 'Solicitado', accessorFn: (req) => moment(req.created_at).format("DD-MM-YYYY"), size: 100 },
        { header: 'Requerimiento', accessorFn: (req) => req.para_comprar === 1 ? "Para comprar" : "Interno", size: 100 },
        { header: 'Estado', accessorFn: (req) => req.id_oc ? `${req.valor_estado} (${req.id_oc})` : `${req.valor_estado}` }
        ], []);

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "success",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: { pageIndex: 0, pageSize: 1000 },
    };

    const tableHeadCellProps = {
        align: "center",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };

    const handleViewData = (data) => {
        setopenclose(true)
        setdataReq(data)
    };

    return (
        <div>
            <Navbar />
            <Container maxWidth="xl" mt={1} mb={2}>
                {showReqs && showTabla ? (
                    <Box mt={2} boxShadow={3}>
                        <MaterialReactTable
                            columns={columns}
                            data={showReqs}
                            enableBottomToolbar={true}
                            enablePagination={true}
                            enableRowActions
                            enableRowVirtualization
                            initialState={initialState}
                            positionActionsColumn="last"
                            muiTableHeadCellProps={tableHeadCellProps}
                            muiTableBodyCellProps={({ row }) => ({
                                align: "center",
                                sx: {
                                    backgroundColor: "#fff",
                                    color: "black",
                                    borderColor: "black",
                                },
                            })}
                            enableColumnActions={false}
                            enableDensityToggle={false}
                            muiSearchTextFieldProps={muiSearchTextFieldProps}
                            layoutMode='grid'
                            enableHiding={false}
                            localization={MRT_Localization_ES}
                            enableColumnDragging={false}
                            renderTopToolbarCustomActions={() => (
                                <Typography variant="poster" fontSize={26}>
                                    Historial requerimientos rechazados
                                </Typography>
                            )}
                            renderRowActionMenuItems={({ closeMenu, row }) => [
                                <MenuItem
                                    key={0}
                                    // disabled={(row.original.estado !== 49) && (row.original.estado) !== 87 && (row.original.estado !== 93)}
                                    onClick={() => {
                                        handleViewData(row.original)
                                        closeMenu();
                                    }}
                                    sx={{ m: 0 }}>
                                    <ListItemIcon>
                                        <Preview color="secondary" />
                                    </ListItemIcon>
                                    Visualizar
                                </MenuItem>
                            ]}
                        />
                    </Box>
                ) : null}
            </Container>

            {
                openclose &&
                <Dialog open={openclose} onClose={() => setopenclose(false)} fullWidth maxWidth="sm">
                    <DialogTitle sx={{ bgcolor: "#1F618D", color: "#fff", fontWeight: "bold" }}>
                        Requerimiento #{dataReq.id}
                    </DialogTitle>

                    <DialogContent sx={{ py: 3 }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2}}>
                            <Box>
                                <Typography variant="subtitle2" color="text.secondary">
                                    Observaciones
                                </Typography>
                                <Typography variant="body1">{dataReq.observaciones_baja || "Sin observaciones"}</Typography>
                            </Box>

                            <Divider />

                            <Box>
                                <Typography variant="subtitle2" color="text.secondary">
                                    Fecha
                                </Typography>
                                <Typography variant="body1">
                                    {dataReq.fecha_rechazado ? moment(dataReq.fecha_rechazado).format("DD-MM-YYYY") : "Sin fecha"}
                                </Typography>
                            </Box>
                        </Box>
                    </DialogContent>
                </Dialog>
            }

        </div>
    )

}